import axiosInstance from "./axiosConfig";

export const getRentalsForCalendar = async (userId) => {
  const { data } = await axiosInstance.get(
    `/${userId}/properties/getDatesForCalender`
  );
  return data;
};
